import styles from './Footer.module.css';
import { LINKS } from '#/constants';

const OPEN_IN_NEW_ICON = `${import.meta.env.VITE_ASSETS_URL}/assets/images/open_in_new.svg`;

export function Footer() {
  return (
    <footer className={styles.footer}>
      <nav className={styles.nav}>
        <a className={styles.link} href={LINKS.terms} target="_blank" rel="noopener noreferrer">
          利用規約
        </a>
        <a className={styles.link} href={LINKS.privacy} target="_blank" rel="noopener noreferrer">
          プライバシーポリシー
          <img className={styles.icon} src={OPEN_IN_NEW_ICON} alt="" />
        </a>
        <a className={styles.link} href={LINKS.help} target="_blank" rel="noopener noreferrer">
          ヘルプ
          <img className={styles.icon} src={OPEN_IN_NEW_ICON} alt="" />
        </a>
        <a className={styles.link} href={LINKS.contact} target="_blank" rel="noopener noreferrer">
          お問い合わせ
          <img className={styles.icon} src={OPEN_IN_NEW_ICON} alt="" />
        </a>
      </nav>
      <p className={styles.copyright}>Copyright&nbsp;&copy;&nbsp;DWANGO&nbsp;Co.,&nbsp;Ltd.</p>
    </footer>
  );
}
